import styled from '@emotion/styled';
import { css } from '@emotion/react';

import theme from 'styles/theme';

const tooltipTextStyles = `
  font-family: ${theme.font.mangueira.medium}, 'Mangueira', sans-serif;
  font-size: 11px;
  font-weight: 500;
  line-height: 14px;
  color: #fff;
`;

const shouldForwardProp = (prop: string) => !prop.startsWith('$');

export const TriggerWrap = styled.div`
  display: inline-flex;
  align-items: center;
`;

export const InfoButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  border: none;
  background: transparent;
  cursor: pointer;
  line-height: 0;
  color: #262626;
  touch-action: manipulation;

  &:hover {
    opacity: 0.75;
  }

  &:focus-visible {
    outline: 2px solid #262626;
    outline-offset: 2px;
    border-radius: 50%;
  }

  svg {
    width: 16px;
    height: 16px;
  }
`;

export const TooltipPanel = styled('div', { shouldForwardProp })<{
  $top: number;
  $left: number;
  $mobile?: boolean;
  $arrowOffset?: number;
}>`
  position: fixed;
  top: ${({ $top }) => $top}px;
  left: ${({ $left }) => $left}px;
  transform: ${({ $mobile }) =>
    $mobile ? 'translate(-50%, 0)' : 'translate(-100%, -50%)'};
  z-index: 9999;
  min-width: ${({ $mobile }) => ($mobile ? 'auto' : '328px')};
  width: ${({ $mobile }) =>
    $mobile ? 'min(328px, calc(100vw - 32px))' : 'max-content'};
  padding: 16px 20px;
  border-radius: 16px;
  background: #262626;
  text-align: left;
  box-sizing: border-box;

  &::after {
    content: '';
    position: absolute;
    border-style: solid;

    ${({ $mobile, $arrowOffset = 0 }) =>
      $mobile
        ? css`
            top: -7px;
            left: calc(50% + ${$arrowOffset}px);
            transform: translateX(-50%);
            border-top: none;
            border-left: 7px solid transparent;
            border-right: 7px solid transparent;
            border-bottom: 7px solid #262626;
          `
        : css`
            top: 50%;
            right: -7px;
            transform: translateY(-50%);
            border-top: 7px solid transparent;
            border-bottom: 7px solid transparent;
            border-left: 7px solid #262626;
          `}
  }
`;

export const TooltipTitle = styled.p`
  margin: 0 0 12px;
  font-family: ${theme.font.mangueira.bold}, 'Mangueira', sans-serif;
  font-size: 11px;
  font-weight: 700;
  line-height: 14px;
  color: #fff;
`;

export const TooltipRows = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const TooltipRow = styled('div', { shouldForwardProp })<{ $mobile?: boolean }>`
  display: grid;
  grid-template-columns: ${({ $mobile }) =>
    $mobile ? '48px 16px minmax(0, 1fr)' : '54px 16px 1fr'};
  align-items: center;
  column-gap: 6px;
`;

export const TooltipLabel = styled.span`
  font-family: ${theme.font.mangueira.bold}, 'Mangueira', sans-serif;
  font-size: 11px;
  font-weight: 700;
  line-height: 14px;
  color: #fff;
  white-space: nowrap;
`;

export const TooltipText = styled('span', { shouldForwardProp })<{ $mobile?: boolean }>`
  ${tooltipTextStyles}
  white-space: ${({ $mobile }) => ($mobile ? 'normal' : 'nowrap')};
`;

export const TooltipIcon = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  line-height: 0;

  svg {
    width: 16px;
    height: 16px;
    display: block;
  }
`;
